import React, { useState, useEffect } from 'react'
import { excel2JsonCutSubHead } from '../../../utils/XlsxUtil'
import axios from '../../../utils/AxiosUtil'
import { billCols, validColumn, MAX_SUBMIT_BILL_NUM, projRmkCol } from '../../../constants/billConstants'
import { FGLOBAL } from '../../../constants/frontGlobal'
import { EditableProTable } from '@ant-design/pro-table';
import { Input, Switch, Button, Modal, Select, Space, message, Upload, Tooltip, Form } from 'antd';
import { upSertAxios, mask, unmask } from '../../../components/reqAndHint'
import './add-bill.less'

import { getDataResourceWithValid, getRecordWithValid } from './billHelper'
import { getDeleteCheckedRows } from '../../../components/table/batchDelFunc'
import { useSelector, useDispatch } from 'react-redux'
import { volunChange } from '../../../reducers/volunteerReducers'
import { projectChange } from '../../../reducers/projectReducers'
const { Option } = Select;


// 新建票据
export default function AddBill() {
    const [form] = Form.useForm();
    const [editableKeys, setEditableRowKeys] = useState([]);//正在编辑状态的行
    const [dataSource, setDataSource] = useState([]);
    const columns = [...billCols];
    const dispatch = useDispatch()
    const langValue = useSelector(state => state.langList.value)
    const volunList = useSelector(state => state.volunList.value)
    const projectList = useSelector(state => state.projectList.value)
    const [fileIsLoading, setFileIsLoading] = useState(false);
    const [selectedRowKeysArr, setSelectedRowkeysArr] = useState([]);
    const [areas, setAreas] = useState(null);
    const [choosenArea, setChoosenArea] = useState('');
    const [serverDate, setServerDate] = useState();
    const [rslctValue, setRslctValue] = useState(false);
    // const [action, setAction] = useState();//'暂存'或'提交'
    const [amount, setAmount] = useState(0);
    const [hasMin, setHasMin] = useState(false);//金额中有负数

    const [volunArr, setVolunarr] = useState([])//志工信息选择框
    const [volCode, setVolcode] = useState({})
    const [projectArr, setProjectArr] = useState([]); // 用途的选择框

    let isFinance = FGLOBAL.get('roleId') && +FGLOBAL.get('roleId') < 4;//财务工作人员
    // 更新表格按钮文本
    const canTextArr = document.querySelectorAll('#bill-canText')
    if (canTextArr.length > 0) {
        canTextArr.forEach(item => {
            item.innerHTML = langValue == 0 ? '取消Cancel' : (langValue == 1 ? '取消' : 'Cancel')
        })
    }
    const saveTextArr = document.querySelectorAll('#bill-saveText')
    if (saveTextArr.length > 0) {
        saveTextArr.forEach(item => {
            item.innerHTML = langValue == 0 ? '保存Save' : (langValue == 1 ? '保存' : 'Save')
        })
    }
    const delTextArr = document.querySelectorAll('#bill-delText')
    if (delTextArr.length > 0) {
        delTextArr.forEach(item => {
            item.innerHTML = langValue == 0 ? '删除Delete' : (langValue == 1 ? '删除' : 'Delete')
        })
    }

    useEffect(() => {

        getUserProject();

        (async function () {
            //获取用户地区（+时间）信息，若无数据，提示
            let areaData = await axios.post('/fund/area/area-by-uid', { uid: sessionStorage.getItem('uid') }, { timeout: 30000 })
                .then(data => {
                    // console.log('获取用户地区信息data**:', data.data);
                    const { userArea, date, volunteerArr } = data.data;
                    dispatch(volunChange({ value: volunteerArr }))
                    // console.log('获取用户地区信息userArea&date:', userArea, date);
                    setServerDate(date);
                    let areas = userArea ?.map(area => {
                        return { areaId: area.aid, areaName: area.key }
                    });

                    if (!areas || !areas.length) {
                        Modal.error({ title: '待处理：', content: "当前用户未关联地区，请联系财务同仁修改" });
                        return null;
                    } else {
                        return areas;
                    }
                })
                .catch(e => {
                    // console.log('获取用户信息错误：', e);
                    Modal.error({ title: '待处理：', content: "获取用户信息时出错：" + e });
                    return null;
                })
            if (areaData) {
                setAreas(areaData);
                message.destroy();
                message.info({
                    content: langValue == 0 ? '请选择地区Please select region' : (langValue == 1 ? '请选择地区' : 'Please select region'),
                    duration: 120,
                    style: {
                        fontSize: '1.2rem'
                    }
                });
            }
        })()
        return () => {
            //组件生命结束，销毁全局消息提示
            message.destroy();
        }
    }, [])


    //表格数据变化时，更新总金额
    useEffect(() => {
        //总金额
        let totalAmount = 0;
        let hasMin = false;
        dataSource.forEach((d, i) => {
            let amt = Number(d['金额']);
            totalAmount = Number(amt.toFixed(2)) + Number(totalAmount.toFixed(2));
            totalAmount = Number(totalAmount.toFixed(2));
            if (amt < 0) {
                hasMin = true;
            }
        })

        setHasMin(hasMin);
        // console.log('totalAmount:', totalAmount);
        setAmount(totalAmount);

    }, [dataSource])

    //表格选择框
    const rowSelection = {
        onChange: (selectedRowKeys, selectedRows) => {
            // console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
            setSelectedRowkeysArr([...selectedRowKeys]);
        },
    };
    // 根据用户权限获取用途
    const getUserProject = async () => {

        if (projectList.length < 1) {
            let data = await axios.post('/fund/project/getUserProject', { role_id: FGLOBAL.get('roleId') });
            let projectArr = []
            data.data.forEach(item => {
                var obj = {
                    ch_pro: item,
                    en_pro: item,
                }
                projectArr.push(obj)

            })
            console.log('**projectArr:', projectArr)
            dispatch(projectChange({ value: projectArr }))
            setProjectArr(projectArr);
        } else {
            setProjectArr(projectList)
        }
    }


    const getColumns = (col) => {
        // let projectValueEnum = {}
        // projectArr ?.forEach(p => {
        //     let value = { text: p }
        //     projectValueEnum[p] = value;
        // });
        // 设置用途字段的下拉选项 
        // col[5].valueEnum = projectValueEnum;

        // 用途提示
        // let projectStr = '';
        // for (var key in projectValueEnum) {
        //     projectStr += ' "' + key + '" ';
        // }


        col.forEach((item, i) => {
            if (item.dataIndex == '开立票据名称') {
                item.formItemProps = () => {
                    return {
                        rules: [
                            { required: true, message: langValue == 0 ? '必填Required' : (langValue == 1 ? '必填' : 'Required') },
                            { pattern: /^((?![&/\\]).)*$/, message: langValue == 0 ? <>不能包含 & / \\ ，请检查！<br />Cannot contain & / \\, please check!</> : (langValue == 1 ? '不能包含 & / \\ ，请检查！' : 'Cannot contain & / \\, please check!') },
                        ],
                    };
                }
            }
            else if (item.dataIndex == '身份证号') {
                item.formItemProps = () => {
                    return {
                        rules: [
                            { pattern: /^\w{0,18}$/, message: langValue == 0 ? <>不能超过18位<br />Cannot exceed 18 digits</> : (langValue == 1 ? '不能超过18位' : 'Cannot exceed 18 digits') }
                        ],
                    };
                }
            }
            // TODO 暂时不校验
            // else if (item.dataIndex == 'TIN') {
            //     item.formItemProps = () => {
            //         return {
            //             rules: [
            //                 { pattern: /^\w{18}$/, message: langValue == 0 ? <>固定18位，或不填<br />Fixed 18 digits, or empty</> : (langValue == 1 ? '固定18位，或不填' : 'Fixed 18 digits, or empty') },
            //             ],
            //         };
            //     }
            // }
            else if (item.dataIndex == '用途') {
                //@@TODO
                // 渲染用途字段的验证提示
                item.render = (text, record) => {
                    let purposeStr = record['用途'];
                    const arr = projectArr.filter(item => text ?.includes(item ?.ch_pro))
                    let valid = record.purposeValid;
                    // 校验：必填
                    return !valid ? (
                        <Tooltip title={'不存在该项目！'} trigger="hover">
                            <div style={{ color: 'red' }}>
                                {(purposeStr == 'undefined' || !purposeStr) ? '未填' : purposeStr}
                            </div>
                        </Tooltip>
                    ) : (<>{arr[0] ?.ch_pro}</>);
                }
                // 渲染用途组件
                item.renderFormItem = (_, { isEditable }) => {
                    return (
                        <Select
                            placeholder={langValue == 0 ? '请选择(Please select)' : (langValue == 1 ? '请选择' : 'Please select')}
                            showSearch
                        >
                            {projectArr ?.map((item2, index) => {
                                return <Option key={index} value={item2 ?.ch_pro}>{item2 ?.ch_pro}</Option>
                            })}
                        </Select>
                    )
                }
            }
            // @tmpdel
            // else if (item.dataIndex == '非陆籍填1') {
            //     // 渲染选择组件
            //     item.renderFormItem = (_, { isEditable }) => {
            //         return (
            //             <Select
            //                 placeholder={langValue == 0 ? '请选择(Please select)' : (langValue == 1 ? '请选择' : 'Please select')}
            //                 showSearch
            //                 options={[{ label: '1', value: '1' }, { label: ' ', value: '' }]}
            //             >
            //             </Select>
            //         )
            //     }
            // }
            // else if (item.dataIndex == '法人填1，自然人不填') {
            //     // 渲染选择组件
            //     item.renderFormItem = (_, { isEditable }) => {
            //         return (
            //             <Select
            //                 placeholder={langValue == 0 ? '请选择(Please select)' : (langValue == 1 ? '请选择' : 'Please select')}
            //                 showSearch
            //                 options={[{ label: '1', value: '1' }, { label: ' ', value: '' }]}
            //             >
            //             </Select>
            //         )
            //     }
            // }
            //@@志工编号和姓名关联
            else if (item.dataIndex == '志工编号') {
                item.renderFormItem = (_, record) => {

                    return (
                        <Select
                            placeholder={langValue == 0 ? '请选择(Please select)' : (langValue == 1 ? '请选择' : 'Please select')}
                            showSearch
                            onChange={(value) => {
                                console.log('value:', value);
                                console.log('record:', record);
                                // 查找选中的编号对应的志工姓名
                                const selectedVolunteer = volunArr.find(v => v.volunteer_code === value);
                                let fv = {
                                    [`${record.recordKey}`]: {
                                        '志工编号': value,
                                        '志工姓名': selectedVolunteer ? selectedVolunteer.volunteer_name : '',
                                        '志工英文名': selectedVolunteer ? selectedVolunteer.vol_en_name : 'XXXX',
                                    },
                                };
                                console.log('fv:', fv)
                                // // 更新当前行的志工编号和志工姓名
                                record['志工英文名'] = selectedVolunteer ?.vol_en_name;
                                record['志工姓名'] = selectedVolunteer ?.volunteer_name;
                                form.setFieldsValue(fv);
                            }
                            }
                        >
                            {
                                volunArr.map((item2, index) => {
                                    return <Option key={index} value={item2.volunteer_code}>{item2.volunteer_code}</Option>
                                })
                            }
                        </Select >
                    )
                }
            }
            else if (item.dataIndex == '志工姓名') {
                item.renderFormItem = (_, record) => {
                    return (
                        <Select className='white-disable'
                            placeholder={langValue == 0 ? '请选择(Please select)' : (langValue == 1 ? '请选择' : 'Please select')}
                            showSearch
                            disabled
                        >
                            {volunArr.map((item2, index) => {
                                return <Option key={index} value={item2.volunteer_name}>{item2.volunteer_name}</Option>
                            })}
                        </Select>
                    )
                }
            }
            else if (item.dataIndex == '志工英文名') {
                item.renderFormItem = (_, record) => {
                    return (
                        <Select className='white-disable'
                            placeholder={langValue == 0 ? '请选择(Please select)' : (langValue == 1 ? '请选择' : 'Please select')}
                            showSearch
                            disabled
                        >
                            {volunArr.map((item2, index) => {
                                return <Option key={index} value={item2.vol_en_name}>{item2.vol_en_name}</Option>
                            })}
                        </Select>
                    )
                }
            }
            //@INDEX
            if (i != 0 && i != 5 && i != 7 && i != 8 && i != 9 && i != 10 && i != 11) {
                item.renderFormItem = () => {
                    return <Input
                        type="text"
                        size="small"
                        style={{ height: '30px' }}
                        placeholder={langValue == 0 ? '请输入Please enter' : (langValue == 1 ? '请输入' : 'Please enter')}
                    />
                }
            }
        })

        let operCol = {
            title: '操作',
            en_title: 'Operation',
            ch_title: '操作',
            valueType: 'option',
            width: '90px',
            render: (text, record, _, action) => {
                return [
                    <a
                        key="editable"
                        onClick={() => {
                            // console.log("text:", text, record, action);
                            // console.log("record:", record);//行数据的JSON obj
                            // console.log("action:", action);
                            action ?.startEditable ?.(record['序号']);
                        }}
                    >
                        {langValue == 0 ? '编辑Edit' : (langValue == 1 ? '编辑' : 'Edit')}
                    </a>,
                ]
            },
        };
        let newCol = [...col];

        if (FGLOBAL.get('roleId') && +FGLOBAL.get('roleId') < 4) {
            //地区财务窗口以外人员 表头额外字段
            newCol.push(projRmkCol);
        }

        newCol.push(operCol);
        // ***列render时验证列并按需高亮
        newCol.push(validColumn);
        // 中英切换
        // console.log(newCol);
        newCol.forEach((item, i) => {
            if (i == newCol.length - 1) {
                item.render = (text, record, index) => {
                    //整行的验证状态
                    return !record.rcdValid ? (<font color='red'>{langValue == 0 ? <>异常<br />Not Active</> : (langValue == 1 ? '异常' : 'Not Active')}</font>) : (langValue == 0 ? <>正常<br />Active</> : (langValue == 1 ? '正常' : 'Active'));
                }
            }
            // if (item.dataIndex == '邮箱') return
            item.title = langValue == 0 ? <>{item.ch_title}<br />{item.en_title}</> : (langValue == 1 ? item.ch_title : item.en_title)
        })
        return newCol;
    }

    // 监听地区改变
    const selectArea = (value) => {
        // console.log('selectArea:', value);
        message.destroy();//清除消息提示
        const i = value.lastIndexOf('-')
        var id = Number(value.slice(i + 1))
        const selectVolarr = volunList.filter(item => item.aid == id)
        setVolunarr(selectVolarr)
        setChoosenArea(value);
    }


    /**
     * 
     * @param callBack 验证成功的回调
     * @param action '提交'或'暂存'
     */
    function validData(callBack, action) {
        //1.拦截数据为空或超限
        if (!dataSource ?.length) {
            Modal.error({
                title: langValue == 0 ? '待处理Pending processing' : (langValue == 1 ? '待处理' : 'Pending processing'),
                content: langValue == 0 ? <>请先添加数据<br />Please add data first</> : (langValue == 1 ? '请先添加数据' : 'Please add data first'),
                okText: langValue == 0 ? '确定Confirm' : (langValue == 1 ? '确定' : 'Confirm'),
                cancelText: langValue == 0 ? '取消Cancle' : (langValue == 1 ? '取消' : 'Cancle'),
            });
            return;
        } else if (dataSource.length > MAX_SUBMIT_BILL_NUM) {
            var str = "一次最多上传" + MAX_SUBMIT_BILL_NUM + "条，当前条数 " + dataSource.length + " ,请分批提交"
            var enstr = "Upload a maximum of " + MAX_SUBMIT_BILL_NUM + "items at once，Current number of items " + dataSource.length + " ,Please submit in batches"
            Modal.error({
                title: langValue == 0 ? '超过最大限制条数Exceeding the maximum limit of entries' : (langValue == 1 ? '超过最大限制条数' : 'Exceeding the maximum limit of entries'),
                content: langValue == 0 ? <>{str}<br />{enstr}</> : (langValue == 1 ? str : enstr),
                okText: langValue == 0 ? '确定Confirm' : (langValue == 1 ? '确定' : 'Confirm'),
                cancelText: langValue == 0 ? '取消Cancle' : (langValue == 1 ? '取消' : 'Cancle'),
            });
            return;
        }
        //2.编辑行未保存
        if (editableKeys[0]) {
            var str = '序号为' + editableKeys[0] + '的数据正在编辑，请先保存该行'
            var enstr = 'The data with serial number' + editableKeys[0] + 'is currently being edited. Please save the row first'
            Modal.error({
                title: langValue == 0 ? '请先保存Please save first' : (langValue == 1 ? '请先保存' : 'Please save first'),
                content: langValue == 0 ? <>{str}<br />{enstr}</> : (langValue == 1 ? str : enstr),
                okText: langValue == 0 ? '确定Confirm' : (langValue == 1 ? '确定' : 'Confirm'),
                cancelText: langValue == 0 ? '取消Cancle' : (langValue == 1 ? '取消' : 'Cancle'),
            });
            return;
        }
        //3.数据格式（rule）校验
        //console.log('submit onClick，datasource*:', dataSource, "datasource str:", JSON.stringify(dataSource));
        let tableValid = true;
        for (let i = 0; i < dataSource.length; i++) {
            if (dataSource[i] ?.rcdValid === false) {
                tableValid = false;
                break;
            }
        }
        if (action != "暂存" && tableValid === false) {
            Modal.error({
                content: (
                    <div>
                        <h2>{langValue == 0 ? <>有数据验证未通过，请点击校验筛选出异常数据并修改<br />Data validation did not pass. Please click on the verification to filter out abnormal data and make modifications</> : (langValue == 1 ? '有数据验证未通过，请点击校验筛选出异常数据并修改' : 'Data validation did not pass. Please click on the verification to filter out abnormal data and make modifications')}。</h2>
                    </div>
                ),
                okText: langValue == 0 ? '确定Confirm' : (langValue == 1 ? '确定' : 'Confirm'),
                cancelText: langValue == 0 ? '取消Cancle' : (langValue == 1 ? '取消' : 'Cancle'),
            });
            return;
        }

        //4.提交前多一次确认
        if (action == '提交') {
            Modal.confirm({
                title: langValue == 0 ? <>提交后将无法修改<br />Once submitted, it cannot be modified</> : (langValue == 1 ? '提交后将无法修改' : 'Once submitted, it cannot be modified'), content: <div style={{ fontSize: 20 }}>
                    <div>{langValue == 0 ? '当前总金额(Current total amount)：' : (langValue == 1 ? '当前总金额：' : 'Current total amount：')}{amount}</div>
                    <div>{langValue == 0 ? <>数据将发送给财务，并无法修改。确认提交？<br />The data will be sent to the finance department and cannot be modified. Confirm submission?</> : (langValue == 1 ? '数据将发送给财务，并无法修改。确认提交？' : 'The data will be sent to the finance department and cannot be modified. Confirm submission?')}</div>
                </div>,
                okText: langValue == 0 ? '确定Confirm' : (langValue == 1 ? '确定' : 'Confirm'),
                cancelText: langValue == 0 ? '取消Cancle' : (langValue == 1 ? '取消' : 'Cancle'),
                onOk: () => {
                    confirmArea();
                }
            });
        } else {
            //暂存则不需要
            confirmArea();
        }


        function confirmArea() {
            if (!choosenArea) {
                Modal.error({ content: langValue == 0 ? <>请先选择地区<br />Please select the region first</> : (langValue == 1 ? '请先选择地区' : 'Please select the region first'), okText: langValue == 0 ? '知道了Yes' : (langValue == 1 ? '知道了' : 'Yes') });
                return;
            } else {
                let areaName = choosenArea.split('-')[0];
                Modal.confirm({
                    title: langValue == 0 ? '地区确认Confirm Region：' : (langValue == 1 ? '地区确认：' : 'Confirm Region：'),
                    content: (
                        <div>
                            <p>{langValue == 0 ? '请确认您上传的记录都属于Please confirm that all the records you uploaded belong to' : (langValue == 1 ? '请确认您上传的记录都属于' : 'Please confirm that all the records you uploaded belong to')}:</p>
                            <p><b>{'     ' + areaName}</b></p>
                        </div>),
                    okText: langValue == 0 ? '确定Confirm' : (langValue == 1 ? '确定' : 'Confirm'),
                    cancelText: langValue == 0 ? '取消Cancle' : (langValue == 1 ? '取消' : 'Cancle'),
                    onOk: () => {
                        if (typeof callBack == 'function') {
                            callBack(action);
                        }
                    },
                    onCancel: () => {
                        return;
                    }
                });
            }
        }

    }

    //发送表格数据到后台
    async function sendTableData(action) {
        let url;
        if (action == '暂存') {
            url = '/bill/addTemp';
        } else if (action == '提交') {
            url = '/bill/addSub';
        }
        // console.log(dataSource);
        upSertAxios(url,
            { billDetail: dataSource, area: choosenArea, uid: sessionStorage.getItem('uid') },
            (data) => {
                // console.log('record upSert成功');
                //模拟点击，代替地址跳转，使对应menu被选中
                document.getElementById('/view/bill/list') ?.click();
            },
            (e) => {

                //回调显示弹窗 列出所有错误
                if (e ?.response ?.data ?.hint) {
                    let hint = e.response.data.hint;
                    // console.log('record upSert失败', e?.response?.data?.hint);
                    Modal.destroyAll();
                    Modal.error({
                        width: '50%',
                        title: langValue == 0 ? '错误如下The error is as follows:' : (langValue == 0 ? '错误如下:' : 'The error is as follows:'),
                        centered: true,
                        content: (
                            <div style={{ textAlign: 'left', marginLeft: 48, fontSize: 16 }}>
                                {hint && hint.length > 0 && hint.map((h, i) => {
                                    return (<div key={i} style={{ marginTop: 7, marginBottom: 7 }}>{(i + 1) + '. '}{langValue == 0 ? <>{h.hint}<br />{h.en_hint}</> : (langValue == 1 ? h.hint : h.en_hint)}</div>)
                                })}
                            </div>
                        )
                        ,
                        okText: langValue == 0 ? '知道了Yes' : (langValue == 1 ? '知道了' : 'Yes')
                    });
                }
            },
            60000
        );

    }

    const deleteCheckedRows = (onCleanSelected) => getDeleteCheckedRows(onCleanSelected, editableKeys, selectedRowKeysArr, dataSource, null, setDataSource, null)();

    const handleUpload = async (file) => {
        mask();
        // console.log('一键上传的文件:', file);
        let type = 'tableA'

        let json = await excel2JsonCutSubHead(file, type, isFinance);
        console.log('*****json:', json);

        if (json.title) {
            Modal.error({
                title: json.title,
                content: json.content
            })
            unmask();
            return false;
        }

        // console.log('importExcel xlsx2json:', json);
        // console.log('importExcel json str:', JSON.stringify(json));

        let arr = [...dataSource, ...json];

        //排序
        arr = volunteerSort(arr);
        // console.log('data:', arr);

        //重新标序号
        arr.forEach((j, i) => {
            j['序号'] = i + 1;
        });

        // console.log('start:', start);
        arr = getDataResourceWithValid(arr, projectArr);
        // console.log('arr with valid:', arr);
        // console.log('end:', end);
        //更新表格数据
        setDataSource(arr);
        unmask();
        return false;
    }

    const handleClear = () => {
        Modal.confirm({
            title: '确定清空？', content: "将清空全部信息重新填写",
            onOk: () => {
                setDataSource([]);
            }
        });
    }


    //志工编号升序排序逻辑
    const volunteerSort = (arr) => {
        //过滤带诚的委员 并丢入一个数组
        // let chengVArr = []
        // arr = arr.filter((a) => {
        //     a.志工编号 = String(a.志工编号)
        //     if (a.志工编号.includes('诚')) {
        //         chengVArr.push(a)
        //     }
        //     return !a.志工编号.includes('诚')
        // })

        // @TODO
        // //带诚的委员数组排序
        // chengVArr.sort((a, b) => {
        //     a.志工编号 = String(a ?.志工编号)
        //     b.志工编号 = String(b ?.志工编号)
        //     //过滤编号中的诚，再比较大小
        //     let aCode = a.志工编号.replace('诚', '')
        //     let bCode = b.志工编号.replace('诚', '')
        //     // console.log(a?.志工编号, b?.志工编号);
        //     let aArr = aCode.split('-');
        //     let bArr = bCode.split('-');
        //     // console.log(aArr, bArr);
        //     //按志工编号升序，处理xxx-9比xxx-10大的特殊情况
        //     if (aArr[0] == bArr[0]) {
        //         //编号没有-，比较结果为NaN，需要赋值0 用于比较大小
        //         if (!aArr[1]) aArr[1] = 0
        //         if (!bArr[1]) bArr[1] = 0
        //         return aArr[1] - bArr[1];
        //     } else {
        //         return aArr[0] - bArr[0];
        //     }
        // })
        // console.log('chengVArr:', chengVArr);

        //志工编号排序
        arr.sort((a, b) => {
            a.志工编号 = String(a ?.志工编号)
            b.志工编号 = String(b ?.志工编号)
            // // console.log(a?.志工编号, b?.志工编号);
            // let aArr = a ?.志工编号 ?.split('-');
            // let bArr = b ?.志工编号 ?.split('-');
            // // console.log(aArr, bArr);
            // //按志工编号升序，处理xxx-9比xxx-10大的特殊情况
            // if (aArr[0] == bArr[0]) {
            //     if (!aArr[1]) aArr[1] = 0
            //     if (!bArr[1]) bArr[1] = 0
            //     return aArr[1] - bArr[1];
            // } else {
            //     return aArr[0] - bArr[0];
            // }
            return a.志工编号.localeCompare(b.志工编号);
        })
        //数组合并 带诚的委员放在最后
        // arr = [...arr]

        return arr;
    }
    let Batchstr
    if (langValue == 0) {
        Batchstr = (
            <div style={{ display: 'flex', flexDirection: 'column', lineHeight: 'normal' }}>
                <span>{'批量删除' + (!!rslctValue ? '(开)' : '(关)')}</span>
                <span>{'Batch Deletion' + (!!rslctValue ? '(on)' : '(off)')}</span>
            </div>
        )
    } else if (langValue == 1) {
        Batchstr = (
            <div style={{ display: 'flex', flexDirection: 'column', lineHeight: 'normal' }}>
                <span>{'批量删除' + (!!rslctValue ? '(开)' : '(关)')}</span>
            </div>
        )
    } else {
        Batchstr = (
            <div style={{ display: 'flex', flexDirection: 'column', lineHeight: 'normal' }}>
                <span>{'Batch Deletion' + (!!rslctValue ? '(on)' : '(off)')}</span>
            </div>
        )
    }
    return (
        <div className="add-bill" id="add-bill">
            <div className="base-info">
                <h1 className="info-title">
                    {langValue == 0 ? '基础信息 Basic information' : (langValue == 1 ? '基础信息' : 'Basic information')}
                </h1>
                <div className='bi-content'>
                    <div className='bc-item'>
                        <span>{langValue == 0 ? '录入日期(Date Encoded)' : (langValue == 1 ? '录入日期' : 'Date Encoded')}：</span>
                        <span>{serverDate}</span>
                    </div>
                    <div className='bc-item'>
                        <span>{langValue == 0 ? '地区(Address)' : (langValue == 1 ? '地区' : 'Address')}：</span>
                        <Select style={{ width: 300 }}
                            onChange={selectArea}
                            loading={!areas}
                            placeholder={langValue == 0 ? '请选择地区(Please select region)' : (langValue == 1 ? '请选择地区' : 'Please select region')}
                            showSearch
                        >
                            {areas ?.map(area => {
                                return <Option key={area.areaId} value={area.areaName + '-' + area.areaId}>{area.areaName}</Option>
                            })}
                        </Select>
                    </div>
                    <div className='bc-item'>
                        <span>{langValue == 0 ? '当前总金额(Current Balance)' : (langValue == 1 ? '当前总金额' : 'Current Balance')}：</span>
                        <span>{amount}</span>
                    </div>
                    {/* <div className='bc-item'>
                        <span>志工人数：</span>
                        <span>99位</span>
                    </div> */}
                    <div className="batch-wrapper">

                        {Batchstr}

                        <Switch checked={!!rslctValue} onChange={(checked) => {
                            if (checked) {
                                setRslctValue(rowSelection);
                            } else { setRslctValue(false) }
                        }} />
                    </div>
                </div>
            </div>
            <div className="bill-info">
                <div className="info-title">
                    <span>{langValue == 0 ? '票据信息 Ticket Information' : (langValue == 1 ? '票据信息' : 'Ticket Information')}</span>
                    {hasMin ? <span style={{ color: 'red', paddingLeft: '2.5rem' }}>提醒：有金额为负数</span> : null}
                    <div className='upload-wrapper'>
                        <Button type="primary" style={{ marginRight: '10px', backgroundColor: 'mediumseagreen', borderColor: 'mediumseagreen' }}
                            onClick={handleClear}>{langValue == 0 ? '全部清空Clear all' : (langValue == 1 ? '全部清空' : 'Clear all')}</Button>
                        <Upload
                            beforeUpload={handleUpload}
                            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
                            // showUploadList={{ showRemoveIcon: false }}
                            showUploadList={false}
                            maxCount={1}
                        >
                            <Button type="primary">{langValue == 0 ? '一键导入Import' : (langValue == 1 ? '一键导入' : 'Import')}</Button>
                        </Upload >
                    </div>
                </div>
                <div className='bill-table-container'>
                    <EditableProTable
                        sticky
                        rowKey="序号"//editableKeys
                        scroll={{
                            x: 960,
                        }}
                        recordCreatorProps={
                            {
                                position: 'bottom',
                                //空白时新增行，然后传文件；及传文件，新增行，key的处理。
                                record: () => ({ '序号': dataSource.length + 1 }),
                                type: 'primary',
                                creatorButtonText: langValue == 0 ? '添加一行数据 Add a row of data' : (langValue == 1 ? '添加一行数据' : 'Add a row of data')
                            }
                        }
                        tableAlertOptionRender={({ selectedRowKeys, selectedRows, onCleanSelected }) => {
                            return <Space size={24}>
                                <span>
                                    {selectedRowKeys.length ? (<Button style={{ marginLeft: 8 }} onClick={onCleanSelected}>
                                        {langValue == 0 ? '取消选择Unselected' : (langValue == 1 ? '取消选择' : 'Unselected')}
                                    </Button>) : null}
                                </span>
                                <Button type='primary' ghost
                                    onClick={() => { deleteCheckedRows(onCleanSelected) }}
                                >{langValue == 0 ? '批量删除Batch Deletion' : (langValue == 1 ? '批量删除' : 'Batch Deletion')}</Button>
                            </Space>
                        }}
                        loading={false}
                        controlled={true}
                        columnEmptyText=''//空值时不显示'-',显示空字符串
                        columns={getColumns(columns)}
                        value={dataSource}
                        // onChange={
                        //     (dataSrc) => {
                        //         // console.log('epTable onChange dataSrc:', dataSrc);
                        //         //排序
                        //         // dataSrc = volunteerSort(dataSrc);
                        //         // //重新生成序号
                        //         // dataSrc.forEach((d, i) => {
                        //         //     d['序号'] = i + 1 + "";
                        //         // })
                        //         // setDataSource(dataSrc);
                        //     }
                        // }
                        editable={{
                            form,
                            type: 'single',//一次只编辑一行，else multiple
                            editableKeys: editableKeys,//使用（EditableProTable）rowKey 的配置
                            onlyOneLineEditorAlertMessage: '序号为' + editableKeys[0] + '的数据正在编辑，请先保存该行',
                            onSave: async (rowKey, data, row) => {
                                // console.log("onSave:", 'rowKey:', rowKey, 'data:', data, 'row:', row);
                                console.log('onsave:', data);

                                let ds = volunteerSort(dataSource);
                                ds[rowKey - 1] = data;
                                //重新生成序号
                                ds.forEach((d, i) => {
                                    d['序号'] = i + 1 + "";
                                })
                                setDataSource([...ds]);
                                getRecordWithValid(data, projectArr);
                            },
                            onDelete: async (rowKey, data, row) => {
                                // console.log("onDelete:", rowKey, data, row);
                                let ds = volunteerSort(dataSource);
                                removeItemAtIndex(ds, rowKey - 1);
                                //重新生成序号
                                ds.forEach((d, i) => {
                                    d['序号'] = i + 1 + "";
                                })
                                setDataSource([...ds]);
                            },
                            onChange: (editableKeys, editableRows) => {
                                // console.log("onchange editableKeys:", editableKeys, typeof editableKeys[0]);
                                // console.log("editableRows:", editableRows);
                                setEditableRowKeys(editableKeys);
                            },
                            actionRender: (row, config, defaultDom) => {
                                // console.log("actionRender:", row);

                                return selectedRowKeysArr.includes(row['序号']) ? [defaultDom.save, defaultDom.cancel] : [defaultDom.save, defaultDom.delete, defaultDom.cancel];
                            },
                            saveText: <span id="bill-saveText">{langValue == 0 ? '保存Save' : (langValue == 1 ? '保存' : 'Save')}</span>,
                            deleteText: <span id="bill-delText">{langValue == 0 ? '删除Delete' : (langValue == 1 ? '删除' : 'Delete')}</span>,
                            cancelText: <span id="bill-canText">{langValue == 0 ? '取消Cancel' : (langValue == 1 ? '取消' : 'Cancel')}</span>,
                        }}
                        pagination={{
                            pageSize: 10,
                            pageSizeOptions: [10, 20, 50, 100, 1000],
                            showQuickJumper: true,
                            showSizeChanger: true,//可选每页条数，数据少时仍展示
                        }}
                        bordered
                        // rowClassName={(record, index) => record.notValid ? 'warning' : ''}
                        rowSelection={rslctValue}
                    />
                    <Button
                        style={{ marginLeft: 24, marginBottom: 20 }}
                        type="primary"
                        key="submit"
                        onClick={() => {
                            // console.log('submit onClick，datasource*:', dataSource, "datasource str:", JSON.stringify(dataSource));
                            validData(sendTableData, '提交');
                        }}
                    >
                        {langValue == 0 ? '确定提交Confirm and Submit' : (langValue == 1 ? '确定提交' : 'Confirm and Submit')}
                    </Button>
                    <Button
                        style={{ marginLeft: 24 }}
                        type="ghost"
                        key="temp"
                        onClick={() => {
                            //console.log('temp onClick，datasource*:', dataSource, "datasource str:", JSON.stringify(dataSource));
                            validData(sendTableData, '暂存');
                        }}
                    >
                        {langValue == 0 ? '暂存Save temporarily' : (langValue == 1 ? '暂存' : 'Save temporarily')}
                    </Button>
                </div>
            </div>
        </div >
    )
}

function removeItemAtIndex(arr, index) {
    if (index >= 0 && index < arr.length) {
        arr.splice(index, 1);
    }
    return arr;
}